import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import "./CustomTab.scss";
import { InfoOutlined } from "@mui/icons-material";
import { TabProps } from "../../../utility/interfaces/masterDataInterfaces";
import CustomTooltip from "../../custom-tooltip/CustomTooltip";
interface CustomTabProps {
  tabs: TabProps[];
  value?: number;
  handleTabChange?: (event: React.SyntheticEvent, newValue: number) => void;
  hiddenTabs?: string[];
}

const CustomTab = ({
  tabs,
  value,
  handleTabChange,
  hiddenTabs = [],
}: CustomTabProps) => {
  return (
    <Box>
      <Tabs
        value={value}
        onChange={() => {}}
        className="custom-tab"
        variant="scrollable"
        TabIndicatorProps={{ style: { display: "none" } }}
      >
        {tabs?.map((tab) =>
          !hiddenTabs.includes(tab.globalMenuDisplayName) ? (
            <Tab
              key={tab.globalMenuDisplayName}
              value={tab.globalMenuId}
              className={
                value === tab.globalMenuId
                  ? `selected-tab ${tab.globalMenuDisplayName.length <= 6 ? "short-label" : ""}`
                  : ""
              }
              label={
                <Box
                  className={`tabLabelWrapper ${
                    tab.isEnabled ? "active" : "disabled"
                  }`}
                >
                  <Typography
                    className="tab-label"
                    onClick={(event) => {
                      if (tab.isEnabled) {
                        handleTabChange?.(event, tab.globalMenuId);
                      }
                    }}
                  >
                    {tab.globalMenuDisplayName}
                  </Typography>

                  {!!tab.toolTipText && (
                    <CustomTooltip
                      title={tab.toolTipText}
                      enterTouchDelay={0}
                      leaveTouchDelay={3000}
                    >
                      <InfoOutlined className="tab-icon" />
                    </CustomTooltip>
                  )}
                </Box>
              }
            />
          ) : null
        )}
      </Tabs>
    </Box>
  );
};

export default CustomTab;
